import { useEffect, useRef } from 'react';

// context
import { useRequestParams } from 'js/common/context/RequestParamsContext';

// services
import { triggerQuantcastTrackingPixel } from 'js/auth/utils/quantcastTrackingPixel';

// types
import { SignupSource } from 'js/auth/types/signup';

export function useQuantcastTrackingPixel(signupSource?: SignupSource | string) {
  const { analyticsEnabled } = useRequestParams();
  const prevAnalytics = useRef<boolean>(false);

  const isAtlasRegistration = signupSource === SignupSource.ACCOUNT;

  useEffect(() => {
    if (analyticsEnabled && !prevAnalytics.current && isAtlasRegistration) {
      triggerQuantcastTrackingPixel();
      prevAnalytics.current = true;
    }
  }, [analyticsEnabled]);
}
